module.exports = __webpack_public_path__ + "static/media/Google.4d736ac3.png";